import { type ReactNode } from 'react'

export function StepFooter({
  hint,
  variant = 'card',
  children
}: {
  hint?: ReactNode
  variant?: 'card' | 'divider'
  children: ReactNode
}) {
  return (
    <div
      className={`flex flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:px-6 ${
        variant === 'card'
          ? 'rounded-2xl border border-border bg-page'
          : 'border-t border-border'
      } ${hint === undefined ? 'sm:justify-end' : 'sm:justify-between'}`}
    >
      {hint !== undefined && (
        <span className='text-[12px] text-ink-muted'>{hint}</span>
      )}
      {children}
    </div>
  )
}
